const fakeData = [
  {
    id: "2456897",
    address: {
      province: "اصفهان",
      city: "اصفهان",
    },
    operator: {
      operator_name: "حسام زندیان",
    },
    user_car: "ایسوزو NPR",
    plate_number: "44غ54781",
    quantity: 12,
    user: {
      id: "1",
      first_name: "ایمان",
      last_name: "محمدی",
      driver_phone_number: "09131296900",
    },
    product: {
      id: "",
      name: "روغن موتور CL4 مدل (15W-40) حجم 1 لیتر موتوسل",
      category: "روغن موتور دیزل"
    },
    payable_amount: "750000",
    bills: {
      current_km: "789197",
      next_km: "794197",
      delay_km: 0,
      visit_date: "1401-10-11",
      next_visit_date: "1401-11-11",
    },
    service_center: {
      name: "محمدی"
    },
    purchase_date: {
      purchase_date: "1401-10-11",
      next_purchase_date: "1401-11-11",
      delay_in_purchase: "5",
    },
  },
];

export const get_order_report = (data) => {
  return new Promise((resolve) => {
    resolve({
      code: 200,
      success: true,
      message: "",
      pagination: {
        count: 4,
        pages: 1,
        page: 1,
        limit: 10,
        next: null,
        next_url: null,
        previous: null,
        previous_url: null,
      },
      data: fakeData,
    });
  });
};
